// Spotlight wipes

document.addEventListener("DOMContentLoaded", function() {


	// **
	// Section Intro
	// **

	const introSection = document.querySelector('.section-intro');

    if (introSection) {

        // Select the target element
        const targetElement = document.querySelector('.section-intro');
        const targetElement2 = document.querySelector('.section-intro__heading');

        // Callback function to handle intersection
        const handleIntersection = (entries, observer) => {
            entries.forEach((entry) => {
                // console.log('Entry:', entry);
                // console.log('Is Intersecting:', entry.isIntersecting);
                if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
                    // targetElement.classList.add('scrolled-into-viewport');
                    introSection.classList.add('js-active-state-2');
                    // console.log('scrolled-into-viewport');
                } else {
                    // targetElement.classList.remove('scrolled-into-viewport');
                    introSection.classList.remove('js-ended');
                    introSection.classList.remove('js-active-state-2');
                    introSection.classList.remove('js-active-state-3');
                    // console.log('scrolled-outta-viewport');
                }
            });
        };

        const handleIntersection2 = (entries, observer) => {
            entries.forEach((entry) => {
                // console.log('Entry:', entry);
                // console.log('Is Intersecting:', entry.isIntersecting);
                if (entry.isIntersecting  || entry.boundingClientRect.top < 0) {
                    // targetElement.classList.add('scrolled-into-viewport');
                    introSection.classList.add('js-active-state-3');
                    setTimeout(function() {
                        introSection.classList.add('js-ended');
                    }, 100);
                    // console.log('scrolled-into-viewport');
                } else {
                    // targetElement.classList.remove('scrolled-into-viewport');
                    introSection.classList.remove('js-active-state-3');
                    // console.log('scrolled-outta-viewport');
                }
            });
        };

        // Options for the intersection observer
        // const options2 = {
        //     rootMargin: '-450px 0px 0px 0px', // Adjust the top margin to trigger the intersection
        // 	// threshold: 0.6, // Trigger when 10% of the element is visible in the viewport
        // };

        // Create an intersection observer instance
        const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0% 0% -10px 0%'});
        const observer2 = new IntersectionObserver(handleIntersection2, { rootMargin: '0% 0% -75% 0%'});

        // Observe the target element
        observer.observe(targetElement);
        observer2.observe(targetElement2);

    }




	// **
	// Main footer
	// **

	const sectionName = document.querySelector('.main-footer');


    // Callback function to handle intersection
    const handleIntersection3 = (entries, observer) => {
        entries.forEach((entry) => {
            // console.log('Entry:', entry);
            // console.log('Is Intersecting:', entry.isIntersecting);
            if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
				sectionName.classList.add('js-active-state-2');
                // console.log('scrolled-into-viewport');
            } else {
				sectionName.classList.remove('js-active-state-2');
                // console.log('scrolled-outta-viewport');
            }
        });
    };

    const observer3 = new IntersectionObserver(handleIntersection3, { rootMargin: '0% 0% -20% 0%'});

    observer3.observe(sectionName);

});
